export default __webpack_public_path__ + "static/media/sale__package__1cl.14bdad8b.png";